import { twMerge } from "tailwind-merge";

export interface BreadcrumbsItemProps
  extends React.HTMLAttributes<HTMLDivElement> {}

export default function BreadcrumbsItem(props: Readonly<BreadcrumbsItemProps>) {
  const { className, ...rest } = props;
  return (
    <div
      {...rest}
      className={twMerge(
        "p-1 rounded-lg text-slate-500 font-medium select-none",
        className
      )}
    />
  );
}
